'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _redux = require('redux');

var _reduxThunk = require('redux-thunk');

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

var _reducers = require('reducers');

var _reducers2 = _interopRequireDefault(_reducers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var middlewares = [_reduxThunk2.default];

// add logger middleware for development mode
// if (process.env.NODE_ENV !== 'production') {
//   // MK: All the logs....
//   // http://i.imgur.com/jNgFY.gif
//   // At least collapsing them makes them less IN YOUR FACE
//   const loggerMiddleware = createLogger({
//     collapsed: true
//   })
//   middlewares = [ ...middlewares, loggerMiddleware ]
// }

// Setup the store
/**
 * Setup the store
 */
var configureStore = function configureStore(initialState) {
  return (0, _redux.createStore)(_reducers2.default, initialState, (0, _redux.compose)(_redux.applyMiddleware.apply(undefined, middlewares), window.devToolsExtension ? window.devToolsExtension() : function (f) {
    return f;
  }));
};

// Export
exports.default = configureStore;


//////////////////
// WEBPACK FOOTER
// ./src/configureStore.js
// module id = 343
// module chunks = 1